module.exports = __webpack_public_path__ + "static/logo-saf-b0ad9393e51e3d99bd2648f08b55ad93.svg";